import RNIdNowVILibraryModule from './RNIdNowVILibraryModule';

export function startIdent(token: string): string {
  return RNIdNowVILibraryModule.startIdent(token);
}